import _ from 'lodash';
import toMM from './toMM';

export default function getItemMeasurement(item, typeName) {
  return _.head((item.ItemMeasureList.ItemMeasure || [])
    .filter((measure) => measure.ItemMeasureTypeNameEn === typeName)
    .map(toMM)); // TODO: handle imperial
}
